import FlightCitySelector from './FlightCitySelector.vue'

/* istanbul ignore next */
FlightCitySelector.install = function (Vue) {
  Vue.component(FlightCitySelector.name, FlightCitySelector)
}

export default FlightCitySelector
